<h1 [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" mat-dialog-title *ngIf="data.title">{{data.title}}</h1>

<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" mat-dialog-content>
  <p *ngIf="data.message" [innerHTML]="data.message"></p>
  <p *ngIf="!data.title">
    <mat-progress-spinner diameter="50" mode="indeterminate" color="primary" strokeWidth="5"
      value="100">
    </mat-progress-spinner>
  </p>

</div>

<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" mat-dialog-actions  *ngIf="data.title">
  <button mat-button *ngIf="data.cancel" (click)="onNoClick(); data.cancel()">Cancel</button>
  <button mat-button *ngIf="data.ok"  (click)="onNoClick(); data.ok();" cdkFocusInitial>Ok</button>
  <button mat-button *ngIf="!data.ok" (click)="onNoClick();" cdkFocusInitial>Ok</button>
</div>